const replaceCar = () => import('@/pages/replaceCar')
// const createReplaceReturn = () => import('@/pages/replaceCar/createReturn')
// const createReplaceDelivery = () => import('@/pages/replaceCar/createDelivery')
const createReplaceReturnCar = () => import('@/pages/replaceCar/createReturnCar')
const createReplaceDeliveryCar = () => import('@/pages/replaceCar/createDeliveryCar')
const createReplaceOrder = () => import('@/pages/replaceCar/createReplaceOrder')
const replaceCarDetail = () => import('@/pages/replaceCar/replaceCarDetail')
export default [{
  path: '/replaceCar',
  name: 'replaceCar',
  component: replaceCar,
  meta: {
    storeKey: 'trs.replaceCar.index'
  }
},
{
  path: '/replaceCarDetail',
  name: 'replaceCarDetail',
  component: replaceCarDetail,
  meta: {}
},
{
  path: '/createReplaceOrder',
  name: 'createReplaceOrder',
  component: createReplaceOrder,
  meta: {}
},
{
  path: '/createReplaceDelivery',
  name: 'createReplaceDelivery',
  component: createReplaceDeliveryCar,
  meta: {}
},
{
  path: '/createReplaceReturn',
  name: 'createReplaceReturn',
  component: createReplaceReturnCar,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/replaceCar/index.js